import { ethers} from "ethers";
export const networks = [369];

export const ChainId = {
  MAINNET: 369,
};

export const routerAddress = new Map();
routerAddress.set(ChainId.MAINNET, "0x2221EEa96821E537F100C711dE439F79451c6A01");

export const primaryProvider = new ethers.providers.JsonRpcProvider("https://rpc-pulsechain.g4mm4.io");
export const backupProvider = new ethers.providers.JsonRpcProvider("https://rpc.pulsechain.com");
